import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { NestedEditorRow } from "../nestedRowTypes";
import sharedStyles from "../../ChartOfAccountsTemplateEditor.module.scss";

// Read-only source cell: "Kick" / "Custom" for accounts (derived from
// isManuallyCreated), blank otherwise.
export const NestedSourceCell = memo(
    ({ row }: CellContext<ViewTableFeatures, NestedEditorRow, unknown>) => {
        const { account } = row.original;
        if (!account) {
            return <ViewTableCell />;
        }
        const source = account.isManuallyCreated ? "Custom" : "Kick";
        return (
            <ViewTableCell>
                <span className={sharedStyles.sourceCellText}>{source}</span>
            </ViewTableCell>
        );
    },
);

NestedSourceCell.displayName = "NestedSourceCell";
